import MuiAppBar from "./MuiAppBar";

const index = {
  MuiAppBar
};

export default index;